function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useContext, useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import { AppContext } from 'context';
import history from 'helpers/history';
import { useAction } from 'hooks';
import App from 'modules/App';
import * as constants from '../../constants';
import useEnrollInClinic from '../../partials/EnrollInClinic/useEnrollInClinic';
import WaitForEnrollAcceptedModal from './WaitForEnrollAcceptedModal';
import styles from './EnrollInClinicPage.pcss';
const EnrollInClinicPage = ()=>{
    useStyles(styles);
    const { getUrl } = useContext(AppContext);
    const onClearForm = useAction(App.actions.clearForm, constants.ENROLL_IN_CLINIC_FORM);
    let handleSetIsSucceed;
    const onBack = ()=>{
        const url = getUrl('mobile-my-doctors');
        history.push(url);
    };
    const onCancel = async ()=>{
        handleSetIsSucceed(false);
        onBack();
    };
    const { isSucceed, setIsSucceed, infoMessages, headerMessages, renderEnrollInClinicForm } = useEnrollInClinic(onCancel, true);
    handleSetIsSucceed = setIsSucceed;
    const onOpenModal = useAction(App.actions.openModal, constants.WAIT_FOR_ENROLL_ACCEPTED_MODAL);
    const isSucceedRef = useRef(isSucceed);
    useEffect(()=>{
        if (!isSucceedRef.current && isSucceed) {
            onClearForm();
            onOpenModal();
        }
        isSucceedRef.current = isSucceed;
    }, [
        isSucceed
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessages.provideEnrollCode))
            }),
            renderEnrollInClinicForm(styles.formContainer),
            /*#__PURE__*/ _jsx(WaitForEnrollAcceptedModal, {
                headerMessage: headerMessages.waitForRequestAccepted,
                infoMessage: infoMessages.waitForRequestAccepted,
                onBack: onBack
            })
        ]
    });
};
export default EnrollInClinicPage;
